import type { PopupAd } from "@/types";

export type PopupTone = "active" | "paused" | "scheduled" | "expired";

/** Derives a display status from the enable flag + date window. */
export function popupAdStatus(ad: PopupAd, now = Date.now()): { label: string; tone: PopupTone } {
  if (!ad.isActive) return { label: "Paused", tone: "paused" };
  if (ad.startAt && new Date(ad.startAt).getTime() > now) return { label: "Scheduled", tone: "scheduled" };
  if (ad.endAt && new Date(ad.endAt).getTime() < now) return { label: "Expired", tone: "expired" };
  return { label: "Active", tone: "active" };
}

/** Badge colour per status tone. */
export const POPUP_TONE_CLASS: Record<PopupTone, string> = {
  active: "bg-accent-100 text-accent-900",
  paused: "bg-background-200 text-foreground-600",
  scheduled: "bg-primary-100 text-primary-800",
  expired: "bg-secondary-100 text-secondary-900",
};

/** Converts a stored datetime ("YYYY-MM-DD HH:MM:SS") to a datetime-local value. */
export function toInputDateTime(value: string): string {
  if (!value) return "";
  return value.replace(" ", "T").slice(0, 16);
}

/** Short date label for the cards. */
export function shortDate(value: string): string {
  if (!value) return "";
  return value.slice(0, 10);
}